import TableRow from "@mui/material/TableRow";
import { Box, TableCell } from "@mui/material";
import { useState } from "react";

import ViewIcon from "../../assets/icon/ViewIcon.svg";
import EditIcon from "../../assets/icons/edit.svg";
import DeleteIcon from "../../assets/icon/deleteIcon.svg";

import CustomIcon from "../common/CustomIcon";
import AppSnackbar from "../common/AppSnackbar";
import AddNewShelfModal from "./addNewShelfModal";
import ViewShelfBranchDetails from "./viewShelfBranchDetails";

import { delete_shelf_system } from "../../features/shelfNumberSystem/shelfNumberService";
import { ColorPallet } from "../../utils/colorPallet";

interface IProps {
  shelf?: any;
  handleOpenModal?: () => void;
  setReloadShelf?: any;
}

const ShelfInnerRow = ({ shelf, handleOpenModal, setReloadShelf }: IProps) => {
  const pharmacyId = parseInt(localStorage.getItem("pharmacyId") || "0");

  // Modal States
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);

  // Snackbar States
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error",
  });

  const openSnackbar = (message: string, severity: "success" | "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const handleOpenViewModal = () => setOpenViewModal(true);
  const handleCloseViewModal = () => setOpenViewModal(false);

  const handleDelete = () => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (!confirmed) return;

    deleteShelf(pharmacyId, shelf?.id);
  };

  const deleteShelf = async (pharmacyID: number, shelfID: number) => {
    const dto = { pharmacy_id: pharmacyID, shelf_id: shelfID };

    try {
      const res = await delete_shelf_system(dto);
      if (res?.success) {
        setReloadShelf?.((prev: boolean) => !prev);
        openSnackbar("Deleted Successfully!", "success");
      } else {
        handleDeleteError(res?.message || "Cannot delete shelf.");
      }
    } catch (error: any) {
      handleDeleteError("Cannot delete, shelf has related batches");
    }
  };

  const handleUpdateSuccess = () => {
    setReloadShelf?.((prev: boolean) => !prev);
    openSnackbar("Updated Successfully!", "success");
  };

  const handleUpdateError = (message: string) => {
    openSnackbar(message || "Update Failed!", "error");
  };

  const handleAddSuccess = () => {
    setReloadShelf?.((prev: boolean) => !prev);
    openSnackbar("Shelf Added Successfully!", "success");
  };

  const handleAddError = (message: string) => {
    openSnackbar(message || "Shelf Name Already Exists.", "error");
  };

  const handleDeleteError = (message: string) => {
    openSnackbar(message, "error");
  };

  const commonTableCellStyles = {
    borderTop: `1px solid ${ColorPallet.borderColor}`,
    borderRight: `1px solid ${ColorPallet.borderColor}`,
    borderBottom: `1px solid ${ColorPallet.borderColor}`,
    "&.MuiTableCell-root": {
      padding: "5px 0px 5px 15px !important",
    },
  };

  return (
    <>
      <TableRow
        sx={{
          borderLeft: `1px solid ${ColorPallet.borderColor}`,
          borderRight: `1px solid ${ColorPallet.borderColor}`,
        }}
      >
        <TableCell sx={{ ...commonTableCellStyles, width: "25%" }}>
          {shelf?.name}
        </TableCell>

        <TableCell sx={{ ...commonTableCellStyles, width: "25%" }}>
          <Box>
            {Array.isArray(shelf?.batches) && shelf.batches.length > 0
              ? shelf.batches.length
              : "-"}
          </Box>
        </TableCell>

        <TableCell
          sx={{
            ...commonTableCellStyles,
            borderRight: `1px solid ${ColorPallet.borderColor}`,
            width: "10%",
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ cursor: "pointer" }}>
              <CustomIcon
                IconType={ViewIcon}
                title="View"
                onClick={handleOpenViewModal}
              />
            </Box>
            <Box sx={{ cursor: "pointer" }}>
              <CustomIcon
                IconType={EditIcon}
                title="Edit"
                onClick={handleOpenEditModal}
              />
            </Box>
            {Array.isArray(shelf?.batches) && shelf.batches.length > 0 ? (
              <Box sx={{ opacity: 0.3, cursor: "not-allowed" }}>
                <CustomIcon IconType={DeleteIcon} title="Delete" />
              </Box>
            ) : (
              <Box sx={{ cursor: "pointer" }} onClick={handleDelete}>
                <CustomIcon IconType={DeleteIcon} title="Delete" />
              </Box>
            )}
          </Box>
        </TableCell>
      </TableRow>

      {/* Snackbar */}
      <AppSnackbar
        message={snackbar.message}
        open={snackbar.open}
        handleClose={handleSnackbarClose}
        severity={snackbar.severity}
      />

      {/* Modals */}
      {openEditModal && (
        <AddNewShelfModal
          handleClose={handleCloseEditModal}
          isEdit={true}
          initialData={shelf}
          setReloadShelf={setReloadShelf}
          onUpdateSuccess={handleUpdateSuccess}
          onUpdateError={handleUpdateError}
          onAddSuccess={handleAddSuccess}
          onAddError={handleAddError}
        />
      )}

      {openViewModal && (
        <ViewShelfBranchDetails
          handleClose={handleCloseViewModal}
          initialData={shelf}
        />
      )}
    </>
  );
};

export default ShelfInnerRow;
